// extracted by mini-css-extract-plugin
export default {"termsContainer":"Terms_termsContainer__UE3Ay","termsBox":"Terms_termsBox__rlUo4","termsBox1":"Terms_termsBox1__s4BAz","termBox2":"Terms_termBox2__uuwEg"};